module.exports = __webpack_public_path__ + "static/ITCFranklinGothicStd-Demi-090a684783615a2ec35f2cb3653eeec4.woff";